import { useTranslation } from 'react-i18next'

import Text from '../../Text'
import { getBirdviewFlatNumberLabel } from '../DashboardBirdview.utils.rows'

import * as styles from './BirdviewRowAddress.module.css'

function BirdviewRowAddress({ address, assignee, flat }) {
  const { t } = useTranslation()

  return (
    <span className={styles.address}>
      <Text isSecondary className={styles.text} title={address}>
        {address}
      </Text>
      {flat ? (
        <>
          <Text isSecondary className={styles.dot}>
            ·
          </Text>
          <Text isSecondary className={styles.flat}>
            {getBirdviewFlatNumberLabel(flat, t)}
          </Text>
        </>
      ) : null}
      {assignee ? (
        <>
          <Text isSecondary className={styles.dot}>
            ·
          </Text>
          <Text isSecondary className={styles.assignee} title={assignee}>
            {assignee}
          </Text>
        </>
      ) : null}
    </span>
  )
}

export default BirdviewRowAddress
